module.exports = __webpack_public_path__ + "media/images/city/051-tower-of-london-50f2023e02f76c9c501b326739e2cfb8.svg";